import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { SecaoFormulario } from '@/ui/patterns/secao-formulario';
import { Button } from '@/ui/primitives/button';
import { type EmpresaDetalhe, type Endereco, enderecoSchema } from '@fiscoai/contracts';

import { useAtualizarEmpresa } from './api';
import { CamposEndereco, type EnderecoForm } from './campos-endereco';
import { gravar } from './formulario';

/** Sem endereço ainda: nada pré-escolhido (o produto não assume estado nenhum). */
const VAZIO = {
  cep: '',
  logradouro: '',
  numero: '',
  complemento: null,
  bairro: '',
  codigoMunicipio: '',
  municipio: '',
} as Partial<EnderecoForm> as EnderecoForm;

export function AbaEndereco({
  empresa,
  podeEditar,
}: {
  empresa: EmpresaDetalhe;
  podeEditar: boolean;
}) {
  const atualizar = useAtualizarEmpresa(empresa.id);
  const form = useForm<EnderecoForm, unknown, Endereco>({
    resolver: zodResolver(enderecoSchema),
    values: empresa.endereco ?? VAZIO,
  });
  const enviar = form.handleSubmit((endereco) =>
    gravar(() => atualizar.mutateAsync({ endereco }), 'Endereço salvo'),
  );

  return (
    <SecaoFormulario
      titulo="Endereço"
      descricao="O município (código IBGE) e o estado definem regras de ICMS e ISS. Comece pelo CEP."
      aoEnviar={() => void enviar()}
      acoes={
        podeEditar &&
        form.formState.isDirty && (
          <>
            <Button
              variante="fantasma"
              onClick={() => {
                form.reset();
              }}
            >
              Descartar
            </Button>
            <Button type="submit" variante="primario" carregando={atualizar.isPending}>
              Salvar
            </Button>
          </>
        )
      }
    >
      <fieldset disabled={!podeEditar} className="grid gap-4 sm:grid-cols-6">
        <legend className="sr-only">Endereço</legend>
        <CamposEndereco form={form} />
      </fieldset>
    </SecaoFormulario>
  );
}
